import { commonDisplayGroups } from './common';

export const displayGroups = {
	...commonDisplayGroups,
};
